
import pageTitle from '../components/pageTitle'
import pop from '../components/pop'
import inputBox from '../components/input/inputBox'

exports.setComponents =
    // 时间戳转字符(具体到秒数)
    function(Vue) {
      Vue.component('pageTitle', pageTitle)
      Vue.component('pop', pop)
      Vue.component('inputBox', inputBox)
    }    



// WEBPACK FOOTER //
// ./src/utils/components.js